import AllIconsNumber from "@Assets/images/IconsEmotionDictionaryKey.json";
import { getSessionId } from "@redux/memoizedSelectors";
import { RestrictUserAccess } from "@utils/helpers";
import { getterApis } from "@utils/optionsSets/getterApis.js";
import React, { useState } from "react";
import { Overlay, Tab, Tabs } from "react-bootstrap";
import Popover from "react-bootstrap/Popover";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useImages } from "shared/dynamic-imports/index.js";
import { ShowComponentModal } from "shared/modals/index";
import { GenericButton, IconDispatcher } from 'shared/ui-basics/index';
import styled, { css } from "styled-components/macro";
import { useModal } from "use-modal-hook";
import Stickers from "../../features/library/view/library-stickers.jsx";
import CustomTooltip from "../components/CustomTooltip.js";


export default function IconSelector({ addFunction, deleteFunction, selected, button = false, buttonText = "", placement = "top", className, ...rest }) {
	const [key, setKey] = React.useState("emotion");
	const { t } = useTranslation();
	const { emotions, icons } = useImages();
	const IconDB = useSelector((state) => state.libraries.icons);
	const sessionId = useSelector(getSessionId);
	const current_user = useSelector((state) => state.maps.currentUser);
	const access = !RestrictUserAccess(current_user?.roleName?.toLowerCase(), ["viewer", "contributor"]);

	const emo = IconDB?.filter((icon) => icon.category === 100000001);
	const ico = IconDB?.filter((icon) => icon.category === 100000000);
	const [showModal] = useModal(ShowComponentModal);

	const [open, setOpen] = useState(false);
	const ref = React.useRef();
	const openStickersByCategory = (selectedCategory) => {
		showModal({
			title: "MANAGE_STICKERS",
			Component: Stickers,
			defaultCategory: selectedCategory,
		});
		setOpen(false);
	};
	const handleChange = (e) => {
		e.stopPropagation()
		const id = e.currentTarget.id;
		if (selected?.includes(id)) deleteFunction(id);
		else {
			if (selected?.length >= 3) return toast.info(t("LIMIT_ICON"));
			if (selected?.includes(id.toString()) || selected?.includes(String(id).padStart(5, "0"))) return toast.info(t("EXIST_ICON"));
			selected?.length < 3 && addFunction(id);
		}
	};
	const onHide = () => {
		setOpen(false);
	};

	
	return (
		<HideWrapper button={button} id="showIcon" stayOpen={open}>
			<div className="w-100" ref={ref} onClick={() => setOpen(!open)}>
				{button ? (
					<GenericButton variant="actiondropdown" icon="ICONS" >
						<div style={{ marginLeft: '8px' }}>{buttonText} </div>
					</GenericButton>
				) : (
					<GenericButton variant="light-link" size='xs' icon="ICONS" tooltip tooltipText={t("STICKERS")} />

				)}
			</div>
			<div onClick={(e) => e.stopPropagation()}>
				<Overlay show={open} target={ref.current} placement={placement} container={document.body} rootClose onHide={onHide}>
					<CustomPopOver id="popover-basic">
						<Popover.Body className="pb-0">
							<Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
								<Tab eventKey="icon" title={t("ASPX_147")}>
									<IconContainer>
										{ico?.map((key, index) => {
											const url = key.isCustom ? getterApis["GET_CUSTOM_ICON"](key.id, sessionId) : icons[AllIconsNumber[Number(key.number)]]?.default;

											return (
												<IconWrapper key={key.id} id={key.number} onClick={handleChange} selected={selected?.includes(key.number)} access={access}>
													<DragImg isCustom={key.isCustom} src={url} alt={Number(key.number)} />
													{selected?.includes(key.number) && <Revert />}
												</IconWrapper>
											);
										})}
									</IconContainer>
								</Tab>
								<Tab eventKey="emotion" title={t("ASPX_149")}>
									<IconContainer>
										{emo?.map((key, index) => {
											const url = key.isCustom ? getterApis["GET_CUSTOM_ICON"](key.id, sessionId) : emotions[AllIconsNumber[Number(key.number)]]?.default;
											return (
												<CustomTooltip key={key.id} text={key?.name}>
													<IconWrapper key={key.id} id={key.number} onClick={handleChange} selected={selected?.includes(key.number)} access={access}>
														<DragImg isCustom={key.isCustom} src={url} alt={Number(key.number)} />
														{selected?.includes(key.number) && <Revert />}
													</IconWrapper>
												</CustomTooltip>
											);
										})}
									</IconContainer>
								</Tab>
							</Tabs>
						</Popover.Body>
						<div className="p-2 border d-flex justify-content-center">
							<GenericButton
								variant="light-link"
								onClick={() => {
									openStickersByCategory(key === "icon" ? 100000000 : 100000001);
								}}>
								{IconDispatcher("CIRCLE-PLUS", "me-1")}
								{t(key === "icon" ? "MANAGE_ICONS" : "MANAGE_EMOTIONS")}
							</GenericButton>
						</div>
					</CustomPopOver>
				</Overlay>
			</div>
		</HideWrapper>
	);
}
export const AccessWrapper = ({ children }) => {
	const current_user = useSelector((state) => state.maps.currentUser);

	const access = !RestrictUserAccess(current_user?.roleName?.toLowerCase(), ["viewer"]);
	if(!access) {
		return <></>
	}
	return <IconButtonWrapper access={access}>{children}</IconButtonWrapper>;
};

const IconButtonWrapper = styled.div`
	min-height: 24px;
	min-width: 24px;
	display: flex;
	justify-content: center;
	align-items: center;

	${(props) => (!props?.access ? `visibility:hidden;` : `visibility : inherit;`)}
`;
const CustomPopOver = styled(Popover)`
	max-width: 400px;
	z-index: 1088 !important;
`;
const HideWrapper = styled.div`
	display: ${(props) => (props.button || props.stayOpen ? "flex" : "none")};

	${(props) =>
		props.button
			? css`
					width: 100%;
					height: 30px;
					justify-content: center;
					align-items: center;
					display: flex;
					button {
						padding: 4px  8px;
						height: 29px;
					}
					:hover {
						background-color: #EFEFEF;

					}
			  `
			: css`
			  `}
`;

const IconContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	max-height: 173px;
	overflow-y: scroll;
	justify-content: start;
	gap: 3px;
`;
const DragImg = styled.img`
	cursor: pointer;
	z-index: 1;
	width: 25px;
	height: 25px;
	margin: 2px;
`;
const IconWrapper = styled.div`
	margin: 6px;
	position: relative;
	${(props) =>
		props.selected &&
		css`
			border: 1px solid #c4c4c4;
			border-radius: 50%;
			box-shadow: -1px -1px 5px rgba(0, 0, 0, 0.2);
		`}
	overflow:hidden;
	${(props) =>
		!props?.access &&
		css`
			pointer-events: none;
		`}
`;
const Revert = styled.div`
	position: absolute;
	width: 40px;
	height: 40px;
	background-color: #d9d9d9;
	border-top: 1px solid #c4c4c4;
	bottom: -29px;
	right: -21px;
	border-top-right-radius: 50%;
	border-top-left-radius: 50%;
	transform: rotate(-55deg);
`;
const AddIcon = styled.div`
	color: #605f60 !important;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	align-self: center;
`;
